// QuickActionModal.jsx
//import React from 'react';
import '../../styles/Header-css/Hedaer/QuickActionModal.css';

const QuickActionModal = ({ onClose }) => {
  return (
    <div className="quick-action-modal-overlay">
      <div className="quick-action-modal">
        <button className="close-button" onClick={onClose}>×</button>
        <h2>Quick Action Request</h2>

        <form className="quick-action-form">
          <label>Description</label>
          <textarea placeholder="Write your message..." rows="4" />

          <label>Mobile Number</label>
          <input type="tel" placeholder="Enter your mobile number" />

          <label>Email</label>
          <input type="email" placeholder="Enter your email address" />

          <button type="submit" className="submit-button">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default QuickActionModal;
